/**
 * @ngdoc config
 * @name routeProviderConfig
 * @description
 * Sets the routes for the Home section:
 * - The default one (`/`).
 *
 * @param {Service} $routeProvider The interface for the Angular router.
 * @memberof home
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/home', {
    template: '<home></home>',
  })
  .otherwise({ redirectTo: '/home' });
};

export default routeProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/home/configs/routeProvider.config.js